import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Imageurldata from "../../../../Imageurldata";

import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../../../../component/InputText/InputText";

import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";
import config from "../../../../config/config";

const CollaborateSecTwo = () => {
  const [loading, setLoading] = useState(false);

  const [title, setTitle] = useState("");
  const [titleErr, setTitleErr] = useState("");

  const [title1, setTitle1] = useState("");
  const [title1Err, setTitle1Err] = useState("");

  const [title2, setTitle2] = useState("");
  const [title2Err, setTitle2Err] = useState("");

  const [title3, setTitle3] = useState("");
  const [title3Err, setTitle3Err] = useState("");

  const [text1, setText1] = useState("");
  const [text1Err, setText1Err] = useState("");

  const [mobBannerImg, setMobBannerImg] = useState("");
  const [mobBannerImgErr, setMobBannerImgErr] = useState("");
  const [showMbImg, setShowMbImg] = useState("");
  const [checkMobileImgPresent, setCheckMobileImgPresent] = useState("");

  const [desktopBannerImg, setDesktopBannerImg] = useState("");
  const [desktopBannerImgErr, setDesktopBannerImgErr] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState("");
  const [checkDesktopImgPresent, setCheckDesktopImgPresent] = useState("");

  const [img3, setimg3] = useState("");
  const [img3err, setimg3err] = useState("");
  const [showimg3, setshowimg3] = useState("");
  const [checkimg3present, setcheckimg3present] = useState("");

  const image_url = config.azure_object_url;

  const [toastlist, setToastList] = useState([]);
  let toastProperties = null;

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: `Collaborate section 2 saved Successfully`,
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "delete":
        toastProperties = {
          id,
          title: "Success",
          description: "deleted Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  useEffect(() => {
    setShowMbImg(false);
    setShowDesktopImg(false);
    setshowimg3(false);
    let url = new URL(urldata + "admin/getcollaboratesec2");
    // url.searchParams.append("screen", "aboutus");
    // let decoded = decodeURIComponent(url);
    setLoading(true);
    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        let data = response.data.data[0];
        setTitle(data.title ? data.title : "");
        setText1(data.desc ? data.desc : "");

        setMobBannerImg(data.img1 ? image_url + data.img1 : "");
        setDesktopBannerImg(data.img2 ? image_url + data.img2 : "");
        setimg3(data.img3 ? image_url + data.img3 : "");

        setCheckMobileImgPresent(data.img1 ? false : true);
        setCheckDesktopImgPresent(data.img2 ? false : true);
        setcheckimg3present(data.img3 ? false : true);

        setTitle1(data.imgtitle1 ? data.imgtitle1 : "");
        setTitle2(data.imgtitle2 ? data.imgtitle2 : "");
        setTitle3(data.imgtitle3 ? data.imgtitle3 : "");

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);

  const addBannerData = () => {
    let formData = new FormData();
    formData.append("title", title);
    formData.append("desc", "collaborate");
    formData.append("imgtitle1", title1);
    formData.append("imgtitle2", title2);
    formData.append("imgtitle3", title3);

    if (checkMobileImgPresent) {
      formData.append("img1", mobBannerImg);
      setCheckMobileImgPresent(false);
    }
    if (checkDesktopImgPresent) {
      formData.append("img2", desktopBannerImg);
      setCheckDesktopImgPresent(false);
    }

    if (checkimg3present) {
      formData.append("img3", img3);
      setcheckimg3present(false);
    }

    let url = new URL(urldata + "admin/addcollaboratesec2");

    setLoading(true);
    axios({
      method: "post",
      url: url,
      data: formData,
      withCredentials: true,
    })
      .then((response) => {
        setLoading(false);
        showToast("success");
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const submit = () => {
    let formValid = true;

    if (!title) {
      formValid = false;
      setTitleErr("*Please add Title");
    } else {
      setTitleErr("");
    }
    if (!title1) {
      formValid = false;
      setTitle1Err("*Please add Title One");
    } else {
      setTitle1Err("");
    }
    if (!title2) {
      formValid = false;
      setTitle2Err("*Please add Title two");
    } else {
      setTitle2Err("");
    }
    if (!title3) {
      formValid = false;
      setTitle3Err("*Please add Title three");
    } else {
      setTitle3Err("");
    }

    // if (!text1) {
    //   formValid = false;
    //   setText1Err("*Please add Description");
    // } else {
    //   setText1Err("");
    // }

    if (!mobBannerImg) {
      formValid = false;
      setMobBannerImgErr("*Please add title one image");
    } else {
      setMobBannerImgErr("");
    }
    // if(mobBannerImg){
    //   if(mobBannerImg.size / 1024 > 300){
    //     formValid = false;
    //     setMobBannerImgErr('*File Size should be less than 300kb')
    //   }
    // }

    if (!desktopBannerImg) {
      formValid = false;
      setDesktopBannerImgErr("*Please add title two image");
    } else {
      setDesktopBannerImgErr("");
    }
    // if(desktopBannerImg){
    //   if(desktopBannerImg.size / 1024 > 300){
    //     formValid = false;
    //     setDesktopBannerImgErr('*File Size should be less than 300kb')
    //   }
    // }

    if (!img3) {
      formValid = false;
      setimg3err("*Please add title three image");
    } else {
      setimg3err("");
    }

    if (formValid) {
      addBannerData();
    }
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <h1>Collaborate Section Two Details</h1>
      <br></br>
      <Row className="adminhomeaboutSec1">
        {/*sub row 1*/}
        <Col className="column" lg={3}>
          <div className="title">Title:- </div>
        </Col>
        <Col className="column" lg={9}>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            type="text"
          />
          <h4 className="err">{titleErr}</h4>
        </Col>

        {/*sub row 2*/}
        {/* <Col className="column" lg={3}>
          <div className="title">Description:-</div>
        </Col>  
        <Col className="column" lg={9}>
          <input
            value={text1}
            onChange={(e) => setText1(e.target.value)}
            type="text"
          />
          <h4 className="err">{text1Err}</h4>
        </Col> */}
        <Col className="column" lg={3}>
          <div className="title">Title One:-</div>
        </Col>
        <Col className="column" lg={9}>
          <input
            value={title1}
            onChange={(e) => setTitle1(e.target.value)}
            type="text"
          />
          <h4 className="err">{title1Err}</h4>
        </Col>

        <Col className="column" lg={3}>
          <div className="title">Image One :-</div>
          <div className="desc">Size :- 102 × 102</div>
        </Col>
        <Col className="column" lg={9}>
          <input
            id="bannerImage1"
            accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG,  image/svg, image/SVG"
            type="file"
            onChange={(e) => {
              setMobBannerImg(e.target.files[0]);
              setShowMbImg(true);
              setCheckMobileImgPresent(true);
            }}
            name="passport_proof_upload"
          />

          <label htmlFor="bannerImage1" className="d-f" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>

          <div className="d-f jc-sb">
            <div className="fileTxt">File Format : JPG / PNG</div>
          </div>
          <div className="err">{mobBannerImgErr} </div>
          <Col className="column" lg={3}>
            {mobBannerImg !== "" && (
              <img
                src={
                  showMbImg ? URL.createObjectURL(mobBannerImg) : mobBannerImg
                }
                className="img-fluid"
                style={{ width: "100px", height: "100px" }}
              />
            )}
          </Col>
        </Col>

        <Col className="column" lg={3}>
          <div className="title">Title Two:-</div>
        </Col>
        <Col className="column" lg={9}>
          <input
            value={title2}
            onChange={(e) => setTitle2(e.target.value)}
            type="text"
          />
          <h4 className="err">{title2Err}</h4>
        </Col>

        <Col className="column" lg={3}>
          <div className="title">Image Two:-</div>
          <div className="desc">Size :- 81 × 103</div>
        </Col>
        <Col className="column" lg={9}>
          <input
            id="bannerImage"
            accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG,  image/svg, image/SVG"
            type="file"
            onChange={(e) => {
              setDesktopBannerImg(e.target.files[0]);
              setShowDesktopImg(true);
              setCheckDesktopImgPresent(true);
            }}
            name="passport_proof_upload"
          />

          <label htmlFor="bannerImage" className="d-f" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>

          <div className="d-f jc-sb">
            <div className="fileTxt">File Format : JPG / PNG</div>
          </div>
          <div className="err">{desktopBannerImgErr} </div>
          <Col className="column" lg={3}>
            {desktopBannerImg !== "" && (
              <img
                src={
                  showDesktopImg
                    ? URL.createObjectURL(desktopBannerImg)
                    : desktopBannerImg
                }
                className="img-fluid"
                style={{ width: "100px", height: "100px" }}
              />
            )}
          </Col>
        </Col>

        <Col className="column" lg={3}>
          <div className="title">Title Three:-</div>
        </Col>
        <Col className="column" lg={9}>
          <input
            value={title3}
            onChange={(e) => setTitle3(e.target.value)}
            type="text"
          />
          <h4 className="err">{title3Err}</h4>
        </Col>

        <Col className="column" lg={3}>
          <div className="title">Image Three:-</div>
          <div className="desc">Size :- 108 × 103</div>
        </Col>
        <Col className="column" lg={9}>
          <input
            id="bannerImage3"
            accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG,  image/svg, image/SVG"
            type="file"
            onChange={(e) => {
              setimg3(e.target.files[0]);
              setshowimg3(true);
              setcheckimg3present(true);
            }}
            name="passport_proof_upload"
          />

          <label htmlFor="bannerImage3" className="d-f" id="file-drag">
            <img src={upload} className="img-fluid" />
            <div className="chooseTxt">Choose File</div>
          </label>

          <div className="d-f jc-sb">
            <div className="fileTxt">File Format : JPG / PNG</div>
          </div>
          <div className="err">{img3err} </div>
          <Col className="column" lg={3}>
            {img3 !== "" && (
              <img
                src={showimg3 ? URL.createObjectURL(img3) : img3}
                className="img-fluid"
                style={{ width: "100px", height: "100px" }}
              />
            )}
          </Col>
        </Col>

        <Col className="column d-f j-c a-c">
          <Button onClick={submit} title="SUBMIT" />
        </Col>
      </Row>
      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default CollaborateSecTwo;
